import { createSelector } from 'reselect';

const selectDashboardReducer = state => state.dashboardReducer;

export const selectDashboardLicense = createSelector(
  [selectDashboardReducer],
  dashboardReducer => {
    const {
      counterData,
      licenseReference,
      licenseValidity,
      loadingLicenseValidity,
      updateLicense,
      licenseStep,
      basicPlanAvailability,
    } = dashboardReducer;

    return {
      counterData,
      licenseReference,
      licenseValidity,
      basicPlanAvailability,
      loadingLicenseValidity,
      updateLicense,
      licenseStep,
    };
  }
);
